// src/utils.js

/**
 * Creates a debounced version of a function.
 * @param {Function} fn - The function to debounce.
 * @param {number} delay - Delay in milliseconds.
 * @returns {Function} Debounced function.
 */
export function debounce(fn, delay = 300) {
   let timeoutId;
   return function (...args) {
      const context = this;
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(context, args), delay);
   };
}

/**
 * Initializes Bootstrap tab buttons and attaches `shown.bs.tab` listeners.
 * Ensures tabs behave as expected even when manually constructed.
 * Works around Bootstrap's limitation of not firing `shown.bs.tab` for manually created tabs.
 *
 * @param {string} tabSelector - Parent selector for nav tab container (e.g. '#visTabs')
 * @param {Function} onTabShown - Callback function (panelId: string, element: HTMLElement)
 */
export function setupBootstrapTabs(tabSelector, onTabShown) {
   const $tabs = $(`${tabSelector} a[data-bs-toggle="tab"], ${tabSelector} button[data-bs-toggle="tab"]`);

   if ($tabs.length === 0) {
      console.log(`setupBootstrapTabs: no tabs found for selector: ${tabSelector}`);
      return;
   }

   $tabs.each(function () {
      const tabEl = this;

      // Initialize if not already activated
      if (!bootstrap.Tab.getInstance(tabEl)) {
         new bootstrap.Tab(tabEl);
      }

      // Attach listener
      tabEl.addEventListener('shown.bs.tab', (e) => {
         const panelId = e.target.getAttribute('data-bs-target') || e.target.getAttribute('href');
         if (panelId && typeof onTabShown === 'function') {
            onTabShown(panelId, tabEl);
         }
      });
   });
}
